import { Modal } from "antd";
import "./ProjectConflictConfirm.scss";
import type { ProjectConflictCopy } from "../../utils/projectConflictCopy";

function ProjectConflictConfirmContent({
  copy,
}: {
  copy: ProjectConflictCopy;
}) {
  if (!copy.items.length) {
    return <div className="project-conflict-confirm__body">{copy.body}</div>;
  }

  return (
    <div className="project-conflict-confirm">
      <p>{copy.body}</p>
      <ul>
        {copy.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      {copy.footer ? (
        <p className="project-conflict-confirm__footer">{copy.footer}</p>
      ) : null}
    </div>
  );
}

export function confirmProjectConflict(copy: ProjectConflictCopy) {
  return new Promise<boolean>((resolve) => {
    Modal.confirm({
      width: 520,
      autoFocusButton: "cancel",
      maskClosable: true,
      icon: null,
      title: copy.title,
      content: <ProjectConflictConfirmContent copy={copy} />,
      okText: copy.okText,
      cancelText: copy.cancelText,
      className:
        "unsaved-changes-modal blings-confirm-modal project-conflict-confirm-modal",
      cancelButtonProps: {
        id: "modal-cancel",
        className:
          "unsaved-changes-modal__text-button project-conflict-confirm-modal__text-button",
      },
      okButtonProps: {
        id: "modal-ok",
        className:
          "publish unsaved-changes-modal__primary-button project-conflict-confirm-modal__primary-button",
      },
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
}
